import React, { useState, useEffect } from 'react';
import { Wifi, Volume2, Battery } from 'lucide-react';

export const TopBar = () => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (date) => {
    return date.toLocaleTimeString('en-US', { 
      hour: '2-digit', 
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
      timeZone: 'America/New_York'
    });
  };

  const formatDate = (date) => {
    return date.toLocaleDateString('en-US', { 
      weekday: 'short',
      month: 'short', 
      day: 'numeric',
      timeZone: 'America/New_York'
    });
  };

  return (
    <div 
      className="h-6 flex items-center justify-between px-3 border-b border-border select-none"
      style={{ 
        background: 'linear-gradient(180deg, hsl(145 40% 12%) 0%, hsl(0 0% 4%) 100%)'
      }}
    >
      {/* Left side - System name */}
      <div className="flex items-center gap-3">
        <span className="text-primary text-xs font-semibold text-glow">
          TUX OS
        </span>
        <span className="text-muted-foreground text-xs">
          v1.0.0
        </span>
      </div>

      {/* Center - Menu items (decorative) */}
      <div className="flex items-center gap-4">
        <button className="text-primary/70 text-xs hover:text-primary">
          Applications
        </button>
        <button className="text-primary/70 text-xs hover:text-primary">
          Places
        </button>
        <button className="text-primary/70 text-xs hover:text-primary">
          System
        </button>
      </div>

      {/* Right side - System tray */}
      <div className="flex items-center gap-3">
        {/* Network indicator */}
        <Wifi className="w-3 h-3 text-primary/70" />
        
        {/* Volume indicator */}
        <Volume2 className="w-3 h-3 text-primary/70" />
        
        {/* Battery indicator */}
        <div className="flex items-center gap-1">
          <Battery className="w-3 h-3 text-primary/70" />
          <span className="text-primary/70 text-xs">100%</span>
        </div>

        {/* Separator */}
        <div className="w-px h-3 bg-border" />

        {/* Date & Time */}
        <div className="flex items-center gap-2">
          <span className="text-primary/80 text-xs">
            {formatDate(time)}
          </span>
          <span className="text-primary text-xs font-medium text-glow-subtle">
            {formatTime(time)}
          </span>
        </div>
      </div>
    </div>
  );
};
